import { render, staticRenderFns } from "./ModalIcon.vue?vue&type=template&id=c5a49188&scoped=true&"
import script from "./ModalIcon.vue?vue&type=script&lang=js&"
export * from "./ModalIcon.vue?vue&type=script&lang=js&"
import style0 from "./ModalIcon.vue?vue&type=style&index=0&id=c5a49188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a49188",
  null
  
)

export default component.exports